import { clientPath, LpBackendError, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/**
 * `POST /client/:cid/users`. A login that already exists (at another client) keeps its own password, so the
 * password is left out when blank; sending one for such a login is a 409.
 */
export const createUser = async (
  firstname: string,
  lastname: string,
  email: string,
  mobile_no: string,
  password: string,
  scopes: string[],
  reports: string[]
): Promise<any> => {
  try {
    const { id } = await lpRequest('POST', clientPath('/users'), {
      body: {
        firstname,
        lastname,
        email: email.trim(),
        mobile_no: mobile_no.replace(/\s/g, ''),
        password: password?.trim() ? password : undefined, // spaces only count as blank, as the form's check does
        scopes,
        reports
      }
    });

    try {
      return await getUser(id);
    } catch (refreshErr) {
      // The user exists; only the follow-up read failed. The action needs just the id to open the user's page.
      return { id, firstname, lastname, email, mobile_no };
    }
  } catch (err) {
    if (err instanceof LpBackendError && err.status === 409 && /own password/.test(err.message)) {
      throw new LpBackendError(
        "This person already has a Loop login. They'll keep their existing password; leave the password blank.",
        409
      );
    }
    if (err instanceof LpBackendError && /password is required/.test(err.message)) {
      throw new LpBackendError(
        'Enter a password: this email does not have a Loop login yet.',
        err.status
      );
    }
    throw err;
  }
};
